export const isRoundClosing = ( round ) => {
  if (
    round
    && round.manualClosing === false
    && round.status === 'IN_PROGRESS'
    && new Date( Number( round.endDate ) ) <= new Date()
  ) return true;
  return false;
};
